import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { StateService } from './services/state.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { NavbarComponent } from "./shared/navbar/navbar.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { AuthService } from './services/auth.service';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, DatePipe, NgClass, NavbarComponent, SidebarComponent],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Supplier_Onboarding';
  loggedin: boolean = false;
  loading = true;
  subLoading: Subscription;
  subLogin: Subscription;

  constructor(
    private router: Router,
    public state: StateService,
    private cdr: ChangeDetectorRef,
    private auth: AuthService,
  ) {
    this.subLogin = new Subscription();
    this.subLoading = new Subscription();
  }

  ngOnInit(): void {
    this.auth.refreshTokenStart();
    this.subLogin = this.state.loginStatus.subscribe((status) => {
      this.loggedin = status;
    });
    this.state.loading.subscribe((value) => {
      this.loading = value;
      this.cdr.detectChanges();
    });
    this.state.checkLogin();

    // if (!this.loggedin) {
    //   this.router.navigate(['login']);
    // }
    this.state.LoadingOff();
  }

  ngOnDestroy(): void {
    if (this.subLogin) this.subLogin.unsubscribe();
    if (this.subLoading) this.subLoading.unsubscribe();
    this.auth.refreshTokenStop();
  }
}